import { render, staticRenderFns } from "./OurLab.vue?vue&type=template&id=dc1cfb24&"
import script from "./OurLab.vue?vue&type=script&lang=js&"
export * from "./OurLab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports